import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from '@emotion/styled';
import { shouldForwardProp } from './shouldForwardProp';
import { stylingProps } from './system';
import { pseudoProps } from './pseudo';
import { sxProp, truncateProp, visuallyHiddenProp } from './utility';
export var pounce = function pounce(tag) {
  return styled(tag, {
    shouldForwardProp
  })(_templateObject(), stylingProps, pseudoProps, sxProp, truncateProp, visuallyHiddenProp);
};